import { ContextualWarning } from 'common/contextual-warning/contextual-warning.js';
import { getModuleComponentWithErrorBoundary } from 'layout/module-load/module-build.js';
import { DisplayLoading } from 'layout/module-load/module-load-state.js';
import { IModule } from 'redux-state/layout/types.js';
import { DataUrlComponentUpdate } from './dataUrlComponentUpdateRedux.js';
import { ConfigWithDataUrl, UseDataUrlHook } from './dataUrlHook.js';
import { RenderSuspenseComponent } from './renderSuspenseComponent.js';

/** Place Holder Module To Be Used for Testing */
export function DataUrlComponent({
  modulePath,
  isDrawer,
  config,
  childModuleName,
}: IModule<ConfigWithDataUrl> & {
  debug?: boolean;
  childModuleName: string;
}) {
  const [error, queriedConfig] = UseDataUrlHook({ config });
  DataUrlComponentUpdate({ queriedConfig, modulePath, originalConfig: config });

  /**
   * NO HOOKS BELOW THIS LINE
   * RETURN LOTS OF DIFFERENT STATES AND WILL CAUSE RE_RENDER ISSUES
   */
  if (error.isError) {
    console.warn(`[MODULE ERROR] - ${config.name}`);
    if (['development', 'staging'].indexOf(__BUILD_ENV__ ?? '') !== -1) {
      return (
        <ContextualWarning
          maintenance={{
            header: `DataUrl Request: ${config.name}`,
            text: error.url,
            text2: error.msg,
            icon: 'warning-general-red',
            isNotice: true,
            issued: new Date().toISOString(),
          }}
        />
      );
    }
    return null;
  }

  if (queriedConfig) {
    const ModuleComponent = getModuleComponentWithErrorBoundary(queriedConfig.name);
    if (ModuleComponent) {
      return (
        <RenderSuspenseComponent
          childModuleName={childModuleName}
          modulePath={modulePath}
          config={queriedConfig}
          isDrawer={isDrawer}
        >
          {ModuleComponent}
        </RenderSuspenseComponent>
      );
    }
  }

  return <DisplayLoading moduleName={config.name} isMobile={false} />;
}
